import { useEffect, useRef } from 'react';

export const useInterval = (callback: () => void, duration: number | null) => {
  const interval = useRef<any>(null);

  useEffect(() => {
    if (duration === null) return;
    interval.current = setInterval(() => {
      callback();
    }, duration);
    return () => {
      clearInterval(interval.current);
    };
  }, [callback, duration]);

  useEffect(() => {
    if (duration === null) {
      clearInterval(interval.current);
    }
  }, [duration]);

  return interval.current;
};
